import { Menu, Text } from "@mantine/core";
import ReactRoundedImage from "react-rounded-image";
const MenuItem = ({ Name, Icon, id, space, menuItemHandler, RoundedImage }) => {
	return (
		<Menu.Item
			icon={
				Icon ? (
					<Icon strokeWidth={2} color={"white"} width={18} />
				) : (
					<ReactRoundedImage
						roundedColor="none"
						imageWidth="18"
						imageHeight="18"
						roundedSize="0"
						image={RoundedImage}
					/>
				)
			}
			style={{
				color: "white",
				padding: "4px 2px",
			}}
			onClick={() => {
				menuItemHandler(id, space);
			}}
		>
			<Text>{Name}</Text>
		</Menu.Item>
	);
};
export default MenuItem;
